(function () {
  'use strict';

  var navItems = document.querySelectorAll('[data-mega]');
  var panels   = document.querySelectorAll('.hn__mega');
  var overlay  = document.getElementById('ls-mega-overlay');

  var openTimer  = null;
  var closeTimer = null;
  var currentKey = null;

  function closeSearch() {
    var searchPanel = document.getElementById('ls-search-panel');
    if (!searchPanel || !searchPanel.classList.contains('is-open')) return;
    searchPanel.classList.remove('is-open');
    searchPanel.setAttribute('aria-hidden', 'true');
    var searchForm = document.querySelector('[data-ls-search-form]');
    if (searchForm) searchForm.classList.remove('is-active');
    var searchOverlay = document.getElementById('ls-search-overlay');
    if (searchOverlay) searchOverlay.classList.remove('is-active');
  }

  function open(key) {
    closeSearch();
    clearTimeout(closeTimer);
    if (currentKey && currentKey !== key) {
      var prev = document.getElementById('hn-mega-' + currentKey);
      if (prev) { prev.classList.remove('is-open'); prev.setAttribute('aria-hidden', 'true'); }
    }
    var panel = document.getElementById('hn-mega-' + key);
    if (!panel) return;

    var triggerItem = document.querySelector('[data-mega="' + key + '"]');
    var hn = document.querySelector('.hn');
    if (triggerItem && hn) {
      var navRect = triggerItem.getBoundingClientRect();
      var hnRect  = hn.getBoundingClientRect();
      panel.style.setProperty('--indicator-left', (navRect.left + navRect.width / 2 - hnRect.left) + 'px');
    }

    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-active');
    currentKey = key;
    navItems.forEach(function (item) {
      item.classList.toggle('is-active', item.dataset.mega === key);
    });
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeAll, 150);
  }

  function closeAll() {
    clearTimeout(closeTimer);
    panels.forEach(function (p) {
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
    });
    if (overlay) overlay.classList.remove('is-active');
    navItems.forEach(function (item) { item.classList.remove('is-active'); });
    currentKey = null;
  }

  navItems.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      clearTimeout(openTimer);
      var searchPanel = document.getElementById('ls-search-panel');
      var delay = (searchPanel && searchPanel.classList.contains('is-open')) ? 600 : 120;
      openTimer = setTimeout(function () { open(item.dataset.mega); }, delay);
    });
    item.addEventListener('mouseleave', function () { clearTimeout(openTimer); scheduleClose(); });
  });

  panels.forEach(function (panel) {
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', scheduleClose);
  });

  if (overlay) overlay.addEventListener('click', closeAll);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && currentKey) closeAll();
  });
})();
